export const blockIconsAudioandvideoMic = (
	<span className='material-symbols-outlined'>mic</span>
);
